module.exports = "/assets/site/images/net.png?b0ef58cd2cda2071254629a9a80531ca";